import { TYPESLEMONADE } from 'core/utils/lemonade';
import { useEffect, useState } from 'react';

const useDialogLemonadeTemplates = ({ open, disabledTemplates, templates = [] }) => {
  // Usar templates si están disponibles, sino usar TYPESLEMONADE como fallback
  const typesLemonadeToUse = templates.length > 0 ? templates : TYPESLEMONADE;

  const [selectedType, setSelectedType] = useState(typesLemonadeToUse[0]?.id);
  const [availableOptions, setAvailableOptions] = useState(typesLemonadeToUse[0]?.children || []);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [typesLemonadeFiltered, setTypesLemonadeFiltered] = useState(typesLemonadeToUse);

  useEffect(() => {
    if (open) {
      setSelectedTemplate(null);
      setSelectedType(typesLemonadeToUse[0]?.id);
      setAvailableOptions(typesLemonadeToUse[0]?.children || []);
    }
  }, [open, typesLemonadeToUse]);

  useEffect(() => {
    const sourceTypes = templates.length > 0 ? templates : TYPESLEMONADE;

    if (disabledTemplates.length > 0) {
      let newTypes = [];
      for (let parentType of sourceTypes) {
        newTypes = [...newTypes, { ...parentType, children: parentType.children.filter((item) => !disabledTemplates.includes(item.guid)) }];
      }
      newTypes = newTypes.filter((item) => item.children.length > 0);
      setTypesLemonadeFiltered(newTypes);
    } else {
      setTypesLemonadeFiltered(sourceTypes);
    }
  }, [disabledTemplates, templates]);

  return {
    types: typesLemonadeFiltered,
    setAvailableOptions,
    setSelectedTemplate,
    availableOptions,
    selectedType,
    selectedTemplate,
    setSelectedType,
  };
};

export default useDialogLemonadeTemplates;
